import _ from 'lodash'
import { Base64 } from 'js-base64'
import { isRGB, isRGBA, rgbaRe, rgbRe } from '@com/utils/color'

export function encodeLanguages(languages) {
  const cloneLanguages = _.cloneDeep(languages)
  _.each(cloneLanguages, lang => {
    _.each(lang, (item, key) => {
      // 素材仓库中使用的表单校验组件访问对应属性时是使用 . 连接符，如果 key 本身存在 . 就会判定错误，如 download..style.color，download.. 中第一个 . 是素材包中配置 key 本身的，而第二个 .. 是校验组件为了快捷访问对象属性加上去的，其识别规则是 . 就代表属性访问，那么 .. 就会出错
      // 所以先对 key code，当提交给接口或实时预览时，需要先将 key decode
      lang[Base64.encode(key)] = item
      delete lang[key]
    })
  })

  return cloneLanguages
}

/**
 * 将 language 配置被 encode 过后的 key 还原回去
 * @param languages {{}}
 * @returns {{}}
 */
export function decodeLanguages(languages) {
  const cloneLanguages = _.cloneDeep(languages)
  _.each(cloneLanguages, lang => {
    _.each(lang, (item, key) => {
      // 将 decode 后的 key 还原
      lang[Base64.decode(key)] = item
      delete lang[key]
    })
  })
  return cloneLanguages
}

export function cookStyle(style) {
  _.each(style || null, (item, key) => {
    // 因为素材仓库与 playable 使用颜色时格式不一样，所以将 rgba(79, 133, 103, 0.8) 与 rgba(79, 133, 103) 格式的颜色转换成数组表示
    if (isRGBA(item)) {
      const arr = isRGBA(item) ? rgbaRe.exec(item) : null
      if (_.get(arr, '[1]')) {
        style[key] = arr[1].split(',').map(item => Number(item.trim()))
      }
    }
    if (isRGB(item)) {
      const arr = isRGB(item) ? rgbRe.exec(item) : null
      if (_.get(arr, '[1]')) {
        style[key] = arr[1].split(',').map(item => Number(item.trim()))
      }
    }
  })
  return style
}
